export default function SciPy_Getting_Started() {
  return (
    <div>
      <h1>SciPy Getting Started</h1>
    </div>
  );
}
